import { DataSource } from "../databinding/DataSource";
import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";
import { Table } from "../components/table/Table";
import { TableRow } from "../components/table/TableRow";

export enum TableAction {
    DELETE = "delete",
    ADD = "add",
    UPDATE = "update"
}

export interface TableContentsChangedListener extends EventListener<TableContentsChangedEvent> {
}

export class TableContentsChangedEvent extends Event<Table> {
    private _action: TableAction;
    private _tableRow: TableRow;

    constructor(table: Table, tableRow: TableRow, action: TableAction, domEvent?: DomEvent) {
        super(table, domEvent);
        this._tableRow = tableRow;
        this._action = action;
    }

    public getAction() {
        return this._action;
    }

    public getTable(): Table {
        return this.target as Table;
    }

    public getDataSource(): DataSource {
        return this.getTable().dataSource;
    }

    public getTableRow(): TableRow {
        return this._tableRow;
    }
}
